import React, { useState, useEffect } from "react";
import { Button } from "reactstrap";
//Redux
import { connect } from "react-redux";

//API Calls
import { functionsHttpsCallable } from "../../../utils/FirebaseStorage/firebase";

const exportarInforme = functionsHttpsCallable("ape_consultaPersonalizada");

const mapStateToProps = (state) => ({
  usuarioActivo: state,
});

let BodyInformeAPEs = (props) => {
  const exportarInformeAPEs = async () => {
    try {
      props.toggleLoading();
      const request = await exportarInforme();
      let downloadWindow = window.open(
        request.data.data,
        "_blank",
        "noopener,noreferrer"
      );
      if (downloadWindow) downloadWindow.opener = null;
      props.toastSuccess("Descarga Exitosa!");
      props.toggleLoading();
    } catch (error) {
      props.toggleLoading();
      console.log(error);
      props.toastError("Error con la descarga");
    }
  };

  return (
    <div>
      <Button
        onClick={() => {
          exportarInformeAPEs();
        }}
      >
        Generar
      </Button>
    </div>
  );
};
export default connect(mapStateToProps)(BodyInformeAPEs);
